import { Layout, Text } from "@ui-kitten/components";
import { getWidth } from "components/MainContainer";
import { DARK_THEME_PRIMARY } from "constants/";
import { useAppSelector } from "hooks/useAppSelector";
import React from "react";
import {
  Dimensions,
  Keyboard,
  Pressable,
  ScrollView,
  StatusBar,
  StyleSheet,
  View,
} from "react-native";
import { resolveLogo } from "./utils";

interface LoginContainerProps {
  title?: string;
  children: React.ReactNode;
  showFanRallyLogo?: boolean;
}
const LoginContainer: React.FC<LoginContainerProps> = ({
  title,
  children,
  showFanRallyLogo = true,
}) => {
  const tenantThemeColor = useAppSelector(
    (state) => state.tenant.tenantThemeColor
  );
  return (
    <Layout style={{ flex: 1 }}>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: tenantThemeColor,
          width: Dimensions.get("window").width,
        }}
      >
        <StatusBar
          backgroundColor={DARK_THEME_PRIMARY}
          barStyle="light-content"
        />
        <Pressable onPress={Keyboard.dismiss}>
          <View style={styles.form}>
            <View
              style={{
                width: getWidth(),
                alignSelf: "center",
                padding: 24,
              }}
            >
              <Text style={styles.heading}>{title}</Text>
              {showFanRallyLogo && (
                <View style={styles.logo}>{resolveLogo()}</View>
              )}
              {children}
            </View>
          </View>
        </Pressable>
      </ScrollView>
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1 },
  form: {
    display: "flex",
    paddingTop: 45,
    paddingHorizontal: 30,
    flex: 1,
  },
  heading: {
    fontSize: 40,
    color: "white",
    fontWeight: "700",
  },
  logo: {
    marginVertical: 40,
    alignSelf: "center",
  },
});

export default LoginContainer;
